import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 24,
    lg: 28,
    xl: 32
};
const strokeWidths = {
    xs: 1.5,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 4.5
};
const getColorForValue = (colorConfig, value)=>{
    if (!colorConfig) return "#75FFF1";
    if ("string" == typeof colorConfig) return colorConfig;
    const thresholds = Object.keys(colorConfig).map(Number).sort((a, b)=>b - a);
    for (const threshold of thresholds)if (value >= threshold) return colorConfig[threshold];
    return Object.values(colorConfig)[Object.values(colorConfig).length - 1];
};
const Gauge = ({ value, size = "sm", showLabel = false, showCheckmark = false, colors = {
    primary: "#75FFF1",
    secondary: "#5F6063"
} })=>{
    const dimensions = sizes[size];
    const radius = dimensions / 2;
    const stroke = strokeWidths[size];
    const normalizedRadius = radius - stroke / 2;
    const clampedValue = Math.min(100, Math.max(0, value));
    const circumference = 2 * normalizedRadius * Math.PI;
    const progressOffset = (100 - clampedValue) / 100 * circumference;
    const remainingOffset = clampedValue / 100 * circumference + (clampedValue > 0 ? 0.15 * circumference : 0);
    const createPrimaryCircle = (radius)=>`
      M ${radius},0
      a ${radius},${radius} 0 1,1 -${2 * radius},0
      a ${radius},${radius} 0 1,1 ${2 * radius},0
    `;
    const createSecondaryCircle = (radius)=>`
      M ${radius},0
      a ${radius},${radius} 0 1,0 -${2 * radius},0
      a ${radius},${radius} 0 1,0 ${2 * radius},0
    `;
    const primaryColor = getColorForValue(colors.primary, clampedValue);
    const secondaryColor = getColorForValue(colors.secondary, clampedValue);
    const checkmarkSize = +dimensions;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "relative inline-flex items-center justify-center",
        style: {
            width: dimensions,
            height: dimensions
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                height: dimensions,
                width: dimensions,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    transform: `translate(${dimensions / 2}, ${dimensions / 2}) rotate(-90)`,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: createSecondaryCircle(normalizedRadius),
                            stroke: secondaryColor,
                            fill: "none",
                            strokeWidth: stroke,
                            strokeLinecap: "round",
                            transform: "rotate(-27)",
                            style: {
                                transition: "stroke-dashoffset 0.3s linear",
                                strokeDasharray: circumference,
                                strokeDashoffset: remainingOffset
                            }
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: createPrimaryCircle(normalizedRadius),
                            stroke: primaryColor,
                            fill: "none",
                            strokeWidth: stroke,
                            strokeLinecap: "round",
                            style: {
                                transition: "stroke-dashoffset 0.3s linear",
                                strokeDasharray: circumference,
                                strokeDashoffset: progressOffset
                            }
                        })
                    ]
                })
            }),
            showLabel && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                className: `absolute font-medium ${"xs" === size || "sm" === size ? "text-[10px]" : "md" === size ? "text-xs" : "lg" === size ? "text-sm" : "text-base"}`,
                style: {
                    transition: "opacity 0.3s linear"
                },
                children: [
                    Math.round(clampedValue),
                    "%"
                ]
            }),
            showCheckmark && 100 === clampedValue && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                width: checkmarkSize,
                height: checkmarkSize,
                viewBox: "0 0 24 24",
                fill: "none",
                className: "absolute",
                style: {
                    transition: "opacity 0.3s linear"
                },
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M9 12l2 2 4-4",
                    stroke: primaryColor,
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        ]
    });
};
export { Gauge };
